import { Button, Paper, Stack, Typography } from "@mui/material";

export interface ReviewErrorStateProps {
  /** Human-readable error message. */
  message: string;
  /** When provided, a retry button is shown. */
  onRetry?: () => void;
  retryLabel?: string;
  /** Disable the retry button (e.g. while a retry is already in flight). */
  retrying?: boolean;
  /** Wrap in an outlined `Paper` panel (matches the meta-bar error look). */
  card?: boolean;
  testId?: string;
}

/**
 * Shared error block for the Flyer Review feature. Modeled on the existing
 * `FlyerMetaBar` inline error so error handling looks consistent across
 * regions and previously-swallowed hook errors can be surfaced with a retry.
 */
export function ReviewErrorState({
  message,
  onRetry,
  retryLabel,
  retrying,
  card,
  testId,
}: ReviewErrorStateProps) {
  const body = (
    <Stack direction="row" spacing={1.5} alignItems="center">
      <Typography color="error" variant="body2">
        {message}
      </Typography>
      {onRetry ? (
        <Button size="small" onClick={onRetry} disabled={retrying}>
          {retryLabel ?? "Retry"}
        </Button>
      ) : null}
    </Stack>
  );

  if (card) {
    return (
      <Paper variant="outlined" data-testid={testId} sx={{ p: 2, mb: 2 }}>
        {body}
      </Paper>
    );
  }

  return (
    <Stack data-testid={testId} alignItems="center" sx={{ py: 4 }}>
      {body}
    </Stack>
  );
}
